import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconModule } from '@gosuite/icons';

import { PlatSidebarComponent } from './plat-sidebar/plat-sidebar.component';
import { PrrlFormButlerDialogModule } from '../../../shared/components/prrl-form-butler-dialog/prrl-form-butler-dialog.module';
import { PrrlFormButlerTokenService } from '../../../shared/components/prrl-form-butler-dialog/prrl-form-butler-token.service';
import { WebstartModule } from '../../../shared/webstart/webstart.module';

@NgModule({
	declarations: [ PlatSidebarComponent ],
	exports: [ PlatSidebarComponent ],
	imports: [
		CommonModule,
		IconModule,
		RouterModule,
		PrrlFormButlerDialogModule,
		WebstartModule,
	],
	providers: [PrrlFormButlerTokenService],
})
export class PlatSidebarModule {}



// WEBPACK FOOTER //
// ./src/app/layout/components/plat-sidebar/plat-sidebar.module.ts